
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lectures/[...slug]",
      function () {
        return require("private-next-pages/lectures/[...slug].tsx");
      }
    ]);
  